import { useEffect, useState } from "react";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "../../firebase/config";

export default function AdminBio() {
  const [form, setForm] = useState({
    para1: "",
    para2: "",
    designation: "",
    qualification: "",
    location: ""
  });

  useEffect(() => {
    const fetch = async () => {
      const snap = await getDoc(doc(db, "siteContent", "bio"));
      if (snap.exists()) setForm(snap.data());
    };
    fetch();
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const save = async () => {
    await setDoc(doc(db, "siteContent", "bio"), form);
    alert("Bio updated ✅");
  };

  return (
    <div className="admin-section">
      <h2>Biography</h2>

      <textarea
        name="para1"
        placeholder="Paragraph 1"
        value={form.para1}
        onChange={handleChange}
      />

      <textarea
        name="para2"
        placeholder="Paragraph 2"
        value={form.para2}
        onChange={handleChange}
      />

      <input name="designation" value={form.designation} onChange={handleChange} />
      <input name="qualification" value={form.qualification} onChange={handleChange} />
      <input name="location" value={form.location} onChange={handleChange} />

      <button onClick={save}>Save</button>
    </div>
  );
}